import React from 'react'
import classnames from 'classnames';
import slug from 'slug';

import { section } from './settings';
import scaleProjection from './scaleProjection.js';

import './Tooltip.css';

const tooltipGroups = ['Group', 'Type']
const svgWidth = 96;
const svgHeight = 96;

export default class Tooltip extends React.Component {
  constructor(props) {
    super(props)
    this._parseData(props)
  }

  componentWillUpdate(nextProps) {
    if (nextProps.dataKey !== this.props.dataKey) {
      this._parseData(nextProps)
    }
  }

  _parseData(props) {
    this._counts = {};
    tooltipGroups.forEach(group => {
      this._counts[group] = {};
      const groupValues = props.groupsToShow[group].top;
      groupValues.forEach(groupValue => {
        const total = props.tooltip.values.filter(d => {
          return groupValue.name === props.keyFunctions[group](d);
        }).length;
        this._counts[group][groupValue.name] = total;
      });
    });
  }

  _getStateOutline() {
    if (this.props.tooltip.level !== 'state') {
      return null;
    }

    const polygon = this.props.mapFeatures.find(s => {
        return s.properties.NAME === this.props.tooltip.key;
      }).geometry;

    const scaled = scaleProjection(polygon, svgWidth, svgHeight);

    return (
      <svg width={svgWidth} height={svgHeight}>
        <path d={scaled.path(polygon)} fill="none" stroke="black"  />
      </svg>
    )
  }

  _getTitle() {
    if (this.props.tooltip.level === 'state') {
      return this.props.tooltip.key ;
    }
    if (this.props.tooltip.level === 'city') {
      return `${this.props.tooltip.values[0].City}, ${this.props.tooltip.values[0].State}`;
    }
    if (this.props.tooltip.level === 'date') {
      return `${this.props.tooltip.values[0].datePieces[0]}/${this.props.tooltip.values[0].datePieces[2]}`
    }
  }

  render() {
    if (!this.props.tooltip.values.length) {
      return null;
    }
    const title = this._getTitle();
    const topRowData = this._counts[this.props.selectedGroupType];
    const unselectedGroupType = this.props.selectedGroupType === 'Group' ? 'Type' : 'Group'
    const bottomRowData = this._counts[unselectedGroupType];
    const topRowValues = this.props.groupsToShow[this.props.selectedGroupType].top.map(group => {
      if (!group.selected) {
        return null;
      }
      const style = { color: section(group.name).color }
      return (
        <div key={group.name} className={classnames("group", slug(group.name))}>
          <div className="value compactFont" style={style}>{topRowData[group.name]}</div>
          <div className="label">{group.name.replace(/\//g, ' / ')}</div>
        </div>
      )
    });
    const bottomRowValues = Object.keys(bottomRowData).sort((a, b) => {
      return bottomRowData[b] - bottomRowData[a];
    }).map(groupName => {
      const group = this.props.groupsToShow[unselectedGroupType].top.find(d => d.name === groupName)
      if (!group.selected) {
        return null;
      }
      const marginRight = groupName.length > 30 ? 0 : '2em';
      const style = { backgroundColor: section(groupName).color }
      return (
        <span className="group" key={groupName} style={{ marginRight }}>
          <span className="label" style={style}>{groupName.replace(/\//g, ' / ')}</span>
          <span className="value"> ({bottomRowData[groupName]}) </span>
        </span>
      )
    });

    let width = 475; // must match tooltip.css
    if (this.props.tooltip.level !== 'state') {
      width -= svgWidth + 20;
    }
    const tooltipPadding = 10;
    const toLeft = (this.props.tooltip.x > window.innerWidth / 2);
    const left = toLeft ? (
        (
          this.props.tooltip.x - (width * this.props.globalScale) - tooltipPadding
        ) / this.props.globalScale
      ) : (
        (this.props.tooltip.x + tooltipPadding) / this.props.globalScale
      );

    const leafletWidth = 144;
    const leafletOffset = toLeft ? (
        -(leafletWidth + tooltipPadding * 3)
      ) : width + (tooltipPadding * 2);
    const leaflet = this.props.tooltip.leaflet ? (
        <div className='leaflet' style={{ right: `${leafletOffset}px` }}>
          <div
            className='banner'
            style={{
              backgroundColor: section(
                  this.props.tooltip.leaflet[this.props.selectedGroupType]
                ).color
            }}
          >
            {this.props.tooltip.leaflet[this.props.selectedGroupType].replace(/\//g, ' / ')}
          </div>
          <div
            className='label'
            style={{
              backgroundColor: section(this.props.tooltip.leaflet[unselectedGroupType]).color
            }}
          >
            {this.props.tooltip.leaflet[unselectedGroupType].replace(/\//g, ' / ')}
          </div>
          <div className='date'>
            {this.props.tooltip.leaflet.Date}
          </div>
        </div>
      ) : null;

    const tooltipStyle = {
      left,
      top: this.props.tooltip.y / this.props.globalScale,
    }
    return (
      <div className={classnames('tooltip', this.props.selectedGroupType, {
        nonStateLevel: this.props.tooltip.level !== 'state',
        bumpUp: this.props.tooltip.bumpUp,
      })} style={tooltipStyle}>
        <div className="left">
          <div className="title">{title}</div>
          {this._getStateOutline()}
        </div>
        <div className="right">
          <div className="topRow cf">
            <div className="total group">
              <div className="value compactFont">{this.props.tooltip.values.length}</div>
              <div className="label">Total<br />&nbsp;</div>
            </div>
            {topRowValues}
          </div>
          <div className="bottomRow">
            {bottomRowValues}
          </div>
        </div>
        {leaflet}
      </div>
    )
  }
}